import React from "react"

export default function VideoIcon(props) {
  const { stroke, ...oRest } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...oRest}
    >
      <path
        d="M18.3332 7.67714C18.3332 7.13624 18.3332 6.86578 18.2333 6.74055C18.1467 6.63188 18.0168 6.57422 17.8838 6.58543C17.7306 6.59835 17.5521 6.78959 17.1951 7.17207L14.1665 10.417L17.1951 13.6619C17.5521 14.0444 17.7306 14.2356 17.8838 14.2486C18.0168 14.2598 18.1467 14.2021 18.2333 14.0934C18.3332 13.9682 18.3332 13.6977 18.3332 13.1568V7.67714Z"
        stroke={stroke || "#474E57"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.6665 8.45271C1.6665 6.95257 1.6665 6.2025 1.93899 5.62952C2.17867 5.12551 2.56112 4.71574 3.03153 4.45894C3.56631 4.16699 4.26637 4.16699 5.6665 4.16699H10.1665C11.5666 4.16699 12.2667 4.16699 12.8015 4.45894C13.2719 4.71574 13.6543 5.12551 13.894 5.62952C14.1665 6.2025 14.1665 6.95257 14.1665 8.45271V12.3813C14.1665 13.8814 14.1665 14.6315 13.894 15.2045C13.6543 15.7085 13.2719 16.1182 12.8015 16.375C12.2667 16.667 11.5666 16.667 10.1665 16.667H5.6665C4.26637 16.667 3.56631 16.667 3.03153 16.375C2.56112 16.1182 2.17867 15.7085 1.93899 15.2045C1.6665 14.6315 1.6665 13.8814 1.6665 12.3813V8.45271Z"
        stroke={stroke || "#474E57"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
